import React from 'react';
import contactOptions from '../lib/contactOptions.js';
import getContent from 'pp-react-l10n';

export default class HelpSection extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);

  }

  handleClick(option,country, locale) {
    var link;
    if(option.id==='community'){
      if(locale==='nl'){
        link = `${option.link}en`;
      }else if(locale==='pt' && country === 'br'){
        link = `${option.link}es?country.x=bz`;
      }
      else{
        link = `${option.link}${locale}`;
      }
    }else{
     link = option.link || `${option.url}${country}${option.helpOption}`;
    }
    window.open(link, '_blank');
  }

  render() {
    const getHelpHeading = getContent('staticContent');    
    const country = (this.props.country).toLowerCase();
    const locale = (this.props.locale).split('_')[0];
    const helpContainer = this.props.helpContainer;
    const indexing = helpContainer.findIndex(el => el.country.includes(country));
    const fontChange = country === 'vn' && this.props.locale === 'vi_VN' ? 'vnFont' : country === 'jp' && this.props.locale === 'ja_JP'? 'jpFont': '';
    if(indexing !== -1){
      return (
        <aside id  = "help-section">
          <div className="helpsectionContainer">
              <h2 className={`call-header ${fontChange}`}>{getHelpHeading('brc.HelpSection')}</h2>
              <div className="contact-panels">
                  {contactOptions.map((option) => {
                    const optionClicked = this.handleClick.bind(this, option, country, locale);
                    const idIndex = helpContainer.findIndex(el => el.id === option.id);
                    const isCountryAvailbale = helpContainer[idIndex].country.includes(country);
                    if(isCountryAvailbale) {
                      return (
                      <div className="contact-panel" key = {option.id}>
                      <button className={`${option.iconCSS} vx_btn-link`} onClick = {optionClicked}
                        aria-label={`${option.text} icon`} />
                      <div className="channel-content">
                      <button role = "link" className={`vx_btn-link contact-link ${fontChange}`}  data-pa-click={`${option.fpti}`}
                        onClick = {optionClicked}
                        aria-label={`${option.text} link`}>{getHelpHeading(option.text)}</button>
                          <div className={`support-message ${fontChange}`}>{getHelpHeading(option.message)}</div>
                      </div>
                      </div>);
                      }
                  })}
              </div>
          </div> 
        </aside>
      );
    }      
    else{
      return null;
    }

  }

}
